export const withStopPropagation = (onClickHandler: () => void) => {
  return (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClickHandler();
  };
};

type LtiPlatformData = {
  ltiPlatformDisplayName: string;
  ltiPlatformHelpLink: string;
};

const ltiPlatformDataMap: Record<string, LtiPlatformData> = {
  canvas: {
    ltiPlatformDisplayName: 'Canvas',
    ltiPlatformHelpLink:
      'https://help.albert.io/en/articles/5350870-how-do-i-use-canvas-on-albert-as-a-teacher'
  },
  schoology: {
    ltiPlatformDisplayName: 'Schoology',
    ltiPlatformHelpLink:
      'https://help.albert.io/en/articles/6493165-how-do-i-use-schoology-on-albert-as-a-teacher'
  },
  d2l_brightspace: {
    ltiPlatformDisplayName: 'Brightspace/D2L',
    ltiPlatformHelpLink:
      'https://help.albert.io/en/articles/8582262-how-do-i-use-brightspace-d2l-on-albert-as-a-teacher'
  }
};

export const getLtiPlatformData = (ltiPlatformName: string): LtiPlatformData => {
  return (
    ltiPlatformDataMap[ltiPlatformName] || {
      ltiPlatformDisplayName: '',
      ltiPlatformHelpLink: ''
    }
  );
};
